import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import ChildEntityTab from 'registry/child-entities/ChildEntityTab';
import ChildEntityTabState from 'registry/child-entities/ChildEntityTabState';

export default class ChildEntityTabView extends Backbone.View<ChildEntityTabState> {
  initialize(): void {
    // HACK: This is a huge hack to force-rerender the child entity tab if parent entity change affects
    // what's rendered on the tab.
    // TODO(BNCH-11186): Remove this hack after the downstream tab components listens to flux changes.
    this.listenTo(this.model.get('model'), 'change:archiveRecord change:folder', () => {
      ReactDOM.unmountComponentAtNode(this.el);
      this.rerender();
    });
  }

  rerender(): void {
    const parentEntity = this.model.get('model');
    const childSchemaId = this.model.get('childSchemaId');
    renderToDOM(<ChildEntityTab childSchemaId={childSchemaId} parentEntityId={parentEntity.id} />, this.el);
  }

  render(): Backbone.View<ChildEntityTabState> {
    this.rerender();
    return this;
  }

  remove(): Backbone.View<ChildEntityTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

ChildEntityTabView.prototype.className = 'buffer-tab';
